import Quill from "quill";
import htmlEditButton from "quill-html-edit-button";
import ImageUploader from "quill-image-uploader";

window.Quill = Quill;

const imageFromUrlIcon =
	'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><g><path d="M892,873.9h-78.4v19.6c0,54.1-43.9,98-98,98H108c-54.1,0-98-43.9-98-98v-784c0-54.1,43.9-98,98-98h392h36.2v-3l2.8,3h0.3v0.3l271.5,293.7h2.9v3.2l1.3,1.5h-1.3v230.5H892c54.1,0,98,43.9,98,98v137.2C990,830,946.1,873.9,892,873.9 M539.2,81.9v125.6c0,54.1,43.9,98,98,98h113L539.2,81.9z M774.4,344.7H598c-54.1,0-98-43.9-98-98v-196H147.2c-54.1,0-98,43.9-98,98v705.6c0,54.1,43.9,98,98,98h529.2c47.4,0,86.9-33.6,96-78.4H323.6c-54.1,0-98-43.9-98-98V638.7c0-54.1,43.9-98,98-98h450.8V344.7z M694,713.5c7.4-8.2,11.2-18.6,11.2-31.3c0-10-2.5-18.8-7.4-26.5c-4.9-7.8-11.4-13.1-19.6-16.2c-8.2-3-21.2-4.5-39.2-4.5h-71.6v168.4h34V733h6.9c7.8,0,13.5,0.6,17.1,1.9c3.6,1.3,7,3.6,10.3,7c3.2,3.4,9.2,11.7,17.9,24.8l24.6,36.6h40.6l-20.6-32.8c-8.1-13.1-14.6-22.2-19.4-27.4c-4.8-5.1-10.9-9.8-18.2-14.1C675.5,726.9,686.7,721.7,694,713.5 M490.2,756.7c-1,5.7-3.9,10.6-8.8,14.5c-4.9,3.9-12.2,5.9-21.8,5.9c-9.5,0-17-2.1-22.5-6.3c-5.5-4.2-8.9-9.7-10.4-16.6c-0.8-4.3-1.3-13.6-1.3-28.1V635h-34v89.8c0,18.8,1.1,33.1,3.3,42.7c1.5,6.5,4.7,12.7,9.5,18.6c4.8,5.9,11.4,10.8,19.7,14.5c8.3,3.7,20.5,5.6,36.6,5.6c13.3,0,24.1-1.7,32.4-5.1c8.3-3.4,14.9-8,19.8-13.7c4.9-5.8,8.3-12.8,10.2-21.1c1.8-8.4,2.8-22.6,2.8-42.8V635h-34v93.1C491.7,741.4,491.2,751,490.2,756.7 M862.6,775H778V636.3h-34v167h118.5V775z M626.7,706.2h-25.2v-42.7h26.5c13.7,0,22,0.2,24.8,0.6c5.5,0.9,9.8,3.1,12.8,6.6c3,3.5,4.6,8,4.6,13.7c0,5.1-1.1,9.3-3.4,12.7c-2.3,3.4-5.5,5.7-9.5,7.1C653.2,705.5,643,706.2,626.7,706.2 M374.3,486.3L321,508.7l-46.3-120.6c0,0-17.2-20.4-37.6,0c-7.2,9.6-50.7,51.9-50.7,51.9V125.9l221.1,210.3h-62.7c-36.1,0-18.3,37.8-18.3,37.8L374.3,486.3z"/></g></svg>';

class ImageInsertFromUrl {
	constructor(quill, options) {
		// Add button to all quill toolbar instances
		const toolbarModule = quill.getModule("toolbar");
		if (!toolbarModule) {
			throw new Error('quill.htmlEditButton requires the "toolbar" module to be included too');
		}
		let toolbarEl = toolbarModule.container;
		let imageEl = toolbarEl.querySelector(".ql-image")?.parentNode;

		if (!imageEl) {
			console.error(".ql-image not found in toolbar");
			return;
		}

		const button = document.createElement("button");
		button.innerHTML = imageFromUrlIcon;
		button.title = "Ajouter une image via URL";
		button.onclick = this.handleClick(quill);
		imageEl.appendChild(button);
	}

	handleClick = (quill) => (e) => {
		e.preventDefault();
		const range = quill.getSelection();
		const value = prompt("Quel est l'URL de votre image");
		if (value) {
			quill.insertEmbed(range.index, "image", value, Quill.sources.USER);
		}
	};
}

Quill.register("modules/htmlEditButton", htmlEditButton);
Quill.register("modules/imageUploader", ImageUploader);
Quill.register("modules/imageInsertFromUrl", ImageInsertFromUrl);
